import { useUpdateLearnerProcedureStatus } from "@/api/services/main/exam-steps";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { ProcedureStatusSelect } from "@/features/exam-steps/components/ProcedureStatusSelect";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";
import { FC, useCallback } from "react";

export const ProcedureStatusCell: FC<{
  industryId: number;
  learnerId: number;
  value: string;
  options: { value: string; label: string }[];
  isDisabledHandling?: boolean;
}> = ({ industryId, learnerId, value, options, isDisabledHandling }) => {
  const { mutateAsync, isPending } = useUpdateLearnerProcedureStatus();

  const handleChange = useCallback(async (newValue: string) => {
    if (newValue === value) return;
    try {
      await mutateAsync({ industryId, learnerId, key: newValue });
      toast.success(API_SUCCESS_MESSAGE);
    } catch (error) {
      showError(error);
    }
  }, [mutateAsync, industryId, learnerId, value]);

  return (
    <ProcedureStatusSelect
      value={value}
      options={options}
      onChange={handleChange}
      isLoading={isPending}
      disabled={isDisabledHandling}
    />
  );
};
